import Vue from 'vue'
import axios from 'axios'
import { Decimal } from 'decimal.js';
import * as parseDate from 'date-fns/parse'
import { Point } from 'pixi.js'
import { app, grid } from '../../display'
import Room from '../../display/Room'
import Item from '../../display/Item'

const namespaced = true

const state = {
  grid_settled: false,

  id: null,
  title: "名称未設定",
  display_count: 0,
  first_floor_space: 0,
  price: 0,
  prize_updated: null,
  prized: null,
  tanso: 0,
  order_no: 1,
  architect_comment: null,
  architect_id: null,
  public: true,
  deleted: null,
  created: null,
  modified: null,
  is_own: true,

  items: [[], [], []],

  spec_selected: false,
  spec_format: 8,
  pillar_material: 3,           // selectedSpecification1_1
  roof_structure: 1,            // selectedSpecification1_2
  insulation_material: 2,       // selectedSpecification1_3
  exterior_wall_material: 4,    // selectedSpecification2_1
  exterior_roof_material: 4,    // selectedSpecification2_2
  interior_roof_finish: 2,      // selectedSpecification3_1
  interior_wall_finish: 5,      // selectedSpecification3_2
  interior_floor_finish: 2,     // selectedSpecification3_3
  anti_pollen_facility: 4,      // selectedSpecification4_1
  natural_energy_facility: 4,   // selectedSpecification4_2
  floor_heating_facility: 4,    // selectedSpecification4_3
  hot_water_supply_facility: 1, // selectedSpecification4_4

  spec_formats: [
    { label: 'フォレスタイル標準仕様', value: 8 },
    { label: '骨太安心国産材', value: 1 },
    { label: '上質和風モダン', value: 2 },
    { label: 'なんとなく洋風', value: 3 },
    { label: '自然エネルギー充実', value: 4 },
    { label: '抗花粉対策', value: 5 },
    { label: 'とことん健康', value: 6 },
    { label: 'こだわりカスタマイズ', value: 7 },
  ],
  options: {
    pillar_material: [
      { label: '桧通柱１８０角、管柱１２０角', value: 1, tanso: 1.10862 },
      { label: '桧通柱１５０角、管柱１２０角', value: 2, tanso: 1.03276 },
      { label: '桧通柱１３５角、管柱１２０角', value: 3, tanso: 1.00000 },
      { label: '桧通柱１２０角、管柱１２０角', value: 4, tanso: 0.94482 },
      { label: '杉通柱１２０角、管柱１０５角', value: 5, tanso: 0.94482 },
    ],
    roof_structure: [
      { label: '切妻屋根', value: 1, tanso: 1.000 },
      { label: '入母屋屋根', value: 2, tanso: 1.010 },
      { label: '寄棟屋根', value: 3, tanso: 1.010 },
      { label: '片流れ屋根', value: 4, tanso: 0.990 },
    ],
    insulation_material: [
      { label: '荒壁（土壁）', value: 1, tanso: 1 },
      { label: 'グラスウール', value: 2, tanso: 1 },
      { label: 'ロックウール', value: 3, tanso: 1 },
      { label: 'ウレタン吹付け', value: 4, tanso: 1 },
    ],
    exterior_wall_material: [
      { label: 'カラーサイディング', value: 1, tanso: 1 },
      { label: '無塗装吹付', value: 2, tanso: 1 },
      { label: 'モルタル塗吹付', value: 3, tanso: 1 },
      { label: 'ガルバリウム鋼板', value: 4, tanso: 1 },
      { label: '木質板張り', value: 5, tanso: 1 },
    ],
    exterior_roof_material: [
      { label: '日本瓦', value: 1, tanso: 1 },
      { label: '洋風瓦', value: 2, tanso: 1 },
      { label: 'スレート瓦', value: 3, tanso: 1 },
      { label: 'カラーステンレス鋼板', value: 4, tanso: 1 },
      { label: 'ガルバリウム鋼板', value: 5, tanso: 1 },
    ],
    interior_roof_finish: [
      { label: '国産材８０％・クロス２０％', value: 1, tanso: 1.020 },
      { label: '国産材５０％・クロス５０％', value: 2, tanso: 1.010 },
      { label: '国産材３０％・珪藻土３０％・クロス４０％', value: 3, tanso: 1.000 },
      { label: '国産材３０％・珪藻土７０％', value: 4, tanso: 0.990 },
      { label: 'クロス１００％', value: 5, tanso: 0.980 },
    ],
    interior_wall_finish: [
      { label: '国産材８０％・クロス２０％', value: 1, tanso: 1.020 },
      { label: '国産材６０％・クロス４０％', value: 2, tanso: 1.010 },
      { label: '国産材４０％・クロス６０％', value: 3, tanso: 1.000 },
      { label: '国産材８０％・珪藻土２０％', value: 4, tanso: 1.020 },
      { label: '国産材６０％・珪藻土４０％', value: 5, tanso: 1.010 },
      { label: '国産材４０％・珪藻土６０％', value: 6, tanso: 1.000 },
    ],
    interior_floor_finish: [
      { label: '国産材８０％・合板２０％', value: 1, tanso: 1.020 },
      { label: '国産材６０％・合板４０％', value: 2, tanso: 1.010 },
      { label: '国産材４０％・合板６０％', value: 3, tanso: 1.000 },
      { label: '国産材８０％・クッションフロアー２０％', value: 4, tanso: 1.020 },
      { label: '国産材６０％・クッションフロアー４０％', value: 5, tanso: 1.010 },
      { label: '国産材４０％・クッションフロアー６０％', value: 6, tanso: 1.000 },
      { label: '国産材８０％・畳２０％', value: 7, tanso: 1.020 },
    ],
    anti_pollen_facility: [
      { label: '室内物干し', value: 1, tanso: 1 },
      { label: '室内物干し・布団干し', value: 2, tanso: 1 },
      { label: '室内物干し・布団干し・風除室', value: 3, tanso: 1 },
      { label: '仕様なし', value: 4, tanso: 1 },
    ],
    natural_energy_facility: [
      { label: 'ソーラー3KW発電(21㎡)', value: 1, tanso: 1 },
      { label: 'ソーラー4KW発電(28㎡)', value: 2, tanso: 1 },
      { label: 'ソーラー5KW発電(35㎡)', value: 3, tanso: 1 },
      { label: '仕様なし', value: 4, tanso: 1 },
    ],
    floor_heating_facility: [
      { label: '床面３０％３スイッチ床暖房', value: 1, tanso: 1 },
      { label: '床面２０％２スイッチ床暖房', value: 2, tanso: 1 },
      { label: '床面１０％１スイッチ床暖房', value: 3, tanso: 1 },
      { label: '床暖房なし', value: 4, tanso: 1 },
    ],
    hot_water_supply_facility: [
      { label: 'あり', value: 1, tanso: 1 },
      { label: 'なし', value: 2, tanso: 1 },
    ],
  },
}

// １階外壁の高さ
const f1_gaiheki_height = 2800
// ２階外壁の高さ
const f2_gaiheki_height = 2500
// ３階外壁の高さ
const f3_gaiheki_height = 2500
// 天井の高さ
const tenjou_height = 2400

const PER_PIXEL_LENGTH = 22.75
const PER_PRICE_SIZE = 3.3124
const M2_SIZE_ACCURACY = 2
const ROUND_ACCURACY = 5
// let pixelToMM = pixel => {
//   return Math.floor(pixel * PER_PIXEL_LENGTH)
// }
let numLaundering = num => {
  return Math.round(num * Math.pow(10, ROUND_ACCURACY)) / Math.pow(10, ROUND_ACCURACY)
}
// let pixelToM2 = (width, height) => {
//   let size = pixelToMM(width) * pixelToMM(height)
//   let sizeMM = Math.floor((size * Math.pow(10, M2_SIZE_ACCURACY)) / 1000000)
//   return numLaundering(sizeMM / Math.pow(10, M2_SIZE_ACCURACY))
// }
// let pixelToPrice = (price, width, height) => {
//   let size = pixelToM2(width, height)
//   let priceSize = numLaundering(size / PER_PRICE_SIZE)
//   return numLaundering(priceSize * price)
// }

const getters = {
  getFloorItems: state => floor => {
    let index = floor - 1
    return state.items[index] || []
  },
  getItemById: state => itemId => {
    let items = _.flatten(state.items)
    return items.filter(item => item.id == itemId)
  },
  getFloorArea: (state, getters) => floor => {
    if (!state.grid_settled) return 0
    let areaArray = getters.getFloorItems(floor)
      .map(item => grid.getFloor(floor).children.find(child => child.id == item.id))
      .filter(item => item && item.config.type == 'room')
      .map(room => room.area)
    let area = _.sum(areaArray)
    area *= Math.pow(10, M2_SIZE_ACCURACY)
    area = _.floor(area)
    area /= Math.pow(10, M2_SIZE_ACCURACY)
    return numLaundering(area)
  },
  getFloorTsubo: (state, getters) => floor => {
    if (!state.grid_settled) return 0
    let tsuboArray = getters.getFloorItems(floor)
      .map(item => grid.getFloor(floor).children.find(child => child.id == item.id))
      .filter(item => item && item.config.type == 'room')
      .map(item => item.tsubo)
    let tsubo = _.floor(_.sum(tsuboArray), 1)
    tsubo *= Math.pow(10, M2_SIZE_ACCURACY)
    tsubo = _.floor(tsubo)
    tsubo /= Math.pow(10, M2_SIZE_ACCURACY)
    return numLaundering(tsubo)
  },
  allFloorArea(state, getters) {
    if (!state.grid_settled) return 0
    let rooms = state.items.map((items, floorIndex) => {
      let floorItems = grid.getFloor(floorIndex+1).children
      return items.map(item => floorItems.find(child => child.id == item.id))
        .filter(item => item && item.config.type == 'room')
    })
    let area = _.sum(_.flatten(rooms).map(room => room.area))
    area *= Math.pow(10, M2_SIZE_ACCURACY)
    area = _.floor(area)
    area /= Math.pow(10, M2_SIZE_ACCURACY)
    return numLaundering(area)
  },
  allFloorTsubo(state, getters) {
    if (!state.grid_settled) return 0
    return new Decimal(getters.getFloorTsubo(1))
      .plus(getters.getFloorTsubo(2))
      .plus(getters.getFloorTsubo(3))
      .toNumber()
    // let rooms = state.items.map((items, floorIndex) => {
    //   let floorItems = grid.getFloor(floorIndex+1).children
    //   return items.map(item => floorItems.find(child => child.id == item.id))
    //     .filter(item => item && item.config.type == 'room')
    // })
    // let tsubo = _.sum(_.flatten(rooms).map(room => room.tsubo))
    // tsubo *= Math.pow(10, M2_SIZE_ACCURACY)
    // tsubo = _.floor(tsubo)
    // tsubo /= Math.pow(10, M2_SIZE_ACCURACY)
    // return numLaundering(tsubo)
  },
  getYaneSize: (state, getters) => floor => {
    let F = getters.getFloorArea(floor)
    if (F == 0) return 0
    let N = Math.sqrt(F)
    let M = N + 1.5
    let S = Math.sqrt(Math.pow(M / 2, 2) + Math.pow(M / 5, 2))
    let Y = 2 * M * S
    let result
    if (floor == 3) {
      result = Y
    } else {
      let f = getters.getFloorArea(floor + 1)
      let n = Math.sqrt(f)
      let s = Math.sqrt(Math.pow(n / 2, 2) + Math.pow(n / 5, 2))
      let y = 2 * n * s
      result = Y - y
    }
    result = Math.round(result * Math.pow(10, 2)) / Math.pow(10, 2)
    return numLaundering(result)
  },
  allYaneSize(state, getters) {
    return numLaundering(getters.getYaneSize(1) + getters.getYaneSize(2) + getters.getYaneSize(3))
  },
  getGaisyuLength: (state, getters) => (floor, enable_percent = false) => {
    if (!state.grid_settled) return 0
    let items = getters.getFloorItems(floor)
      .map(item => grid.getFloor(floor).children.find(child => child.id == item.id))
      .filter(item => item && item.config.type == 'room')

    let lengths = items.map(item => {
      let rectangle = item.getRoomBounds()
      let length =  rectangle.width * 2 + rectangle.height * 2

      items.filter(i => item.id != i.id).forEach(otherItem => {
        let otherRectangle = otherItem.getRoomBounds()
        let collideLength = 0

        if (rectangle.top == otherRectangle.bottom) {
          collideLength = _.min([rectangle.right, otherRectangle.right]) - _.max([rectangle.left, otherRectangle.left])
          if (collideLength > 0) length -= collideLength
        } else if (rectangle.left == otherRectangle.right) {
          collideLength = _.min([rectangle.bottom, otherRectangle.bottom]) - _.max([rectangle.top, otherRectangle.top])
          if (collideLength > 0) length -= collideLength
        } else if (rectangle.right == otherRectangle.left) {
          collideLength = _.min([rectangle.bottom, otherRectangle.bottom]) - _.max([rectangle.top, otherRectangle.top])
          if (collideLength > 0) length -= collideLength
        } else if (rectangle.bottom == otherRectangle.top) {
          collideLength = _.min([rectangle.right, otherRectangle.right]) - _.max([rectangle.left, otherRectangle.left])
          if (collideLength > 0) length -= collideLength
        }
      })

      length *= grid.shaku3 * 1000

      return enable_percent ? length * (item.config.gaiheki_size_percent / 100) : length
    })

    return numLaundering(_.sum(lengths) / 1000)
    // return numLaundering(pixelToMM(_.sum(lengths)) / 1000)
  },
  getNaisyuLength: (state, getters) => (floor, enable_percent = false) => {
    if (!state.grid_settled) return 0
    let items = getters.getFloorItems(floor)
      .map(item => grid.getFloor(floor).children.find(child => child.id == item.id))
      .filter(item => item && item.config.type == 'room')

    let lengths = items.map(item => {
      let rectangle = item.getRoomBounds()
      let length =  rectangle.width * 2 + rectangle.height * 2

      items.filter(i => item.id != i.id).forEach(otherItem => {
        let otherRectangle = otherItem.getRoomBounds()
        let collideLength = 0

        if (rectangle.top == otherRectangle.bottom) {
          collideLength = _.min([rectangle.right, otherRectangle.right]) - _.max([rectangle.left, otherRectangle.left])
          if (collideLength > 0 && !item.config.room_count && !otherItem.config.room_count) length -= collideLength
        } else if (rectangle.left == otherRectangle.right) {
          collideLength = _.min([rectangle.bottom, otherRectangle.bottom]) - _.max([rectangle.top, otherRectangle.top])
          if (collideLength > 0 && !item.config.room_count && !otherItem.config.room_count) length -= collideLength
        } else if (rectangle.right == otherRectangle.left) {
          collideLength = _.min([rectangle.bottom, otherRectangle.bottom]) - _.max([rectangle.top, otherRectangle.top])
          if (collideLength > 0 && !item.config.room_count && !otherItem.config.room_count) length -= collideLength
        } else if (rectangle.bottom == otherRectangle.top) {
          collideLength = _.min([rectangle.right, otherRectangle.right]) - _.max([rectangle.left, otherRectangle.left])
          if (collideLength > 0 && !item.config.room_count && !otherItem.config.room_count) length -= collideLength
        }
      })

      length *= grid.shaku3 * 1000

      return enable_percent ? length * (item.config.naiheki_size_percent / 100) : length
    })

    return numLaundering(_.sum(lengths) / 1000)
    // return numLaundering(pixelToMM(_.sum(lengths)) / 1000)
  },
  allStairNum(state, getters, rootState, rootGetters) {
    let f = item => {
      let config = rootGetters['item/configById'](item.config_id)
      return config && config.type == 'stair'
    }
    return getters.getFloorItems(1).filter(f).length
         + getters.getFloorItems(2).filter(f).length
         + getters.getFloorItems(3).filter(f).length
  },
  getGaihekiMenseki(state, getters) {
    let result = 0
    result += getters.getGaisyuLength(1, true) * f1_gaiheki_height / 1000
    result += getters.getGaisyuLength(2, true) * f2_gaiheki_height / 1000
    result += getters.getGaisyuLength(3, true) * f3_gaiheki_height / 1000
    result -= getters.gaihekiWindowSize
    return numLaundering(result)
  },
  getNaihekiMenseki(state, getters) {
    let result = 0
    result += getters.getNaisyuLength(1, true) * tenjou_height / 1000
    result += getters.getNaisyuLength(2, true) * tenjou_height / 1000
    result += getters.getNaisyuLength(3, true) * tenjou_height / 1000
    result -= getters.naihekiWindowSize
    return numLaundering(result)
  },
  gaihekiWindowSize(state) {
    if (!state.grid_settled) return 0
    let items = state.items.map((items, floorIndex) => {
      return items.map(item => grid.getFloor(floorIndex+1).children.find(child => child.id == item.id))
        .filter(item => item && item.config.type == 'door')
    })
    return _.sum(_.flatten(items).map(item => item.config.gaiheki_minus_size))
  },
  naihekiWindowSize(state) {
    if (!state.grid_settled) return 0
    let items = state.items.map((items, floorIndex) => {
      return items.map(item => grid.getFloor(floorIndex+1).children.find(child => child.id == item.id))
        .filter(item => item && item.config.type == 'door')
    })
    return _.sum(_.flatten(items).map(item => item.config.naiheki_minus_size))
  },
  price(state, getters, rootState, rootGetters) {
    if (!state.grid_settled) return 0

    let itemList = []
    let priceArray = state.items.map((items, floorIndex) => {
      // let children = grid.getFloor(floorIndex+1).children
      return items.map(item => {
        let config = rootGetters['item/configById'](item.config_id)
        itemList.push(config.label.replace("\n", ' '))
        if (config.type == 'door' || config.type == 'equipment') {
          return config.price
        } else {
          return 0
        }
        // let instance = children.find(child => child.id == item.id)
        // if (instance) {
        //   console.log(instance.config.label.replace("\n", ' '))
        //   if (instance.config.type == 'room') {
        //     return pixelToPrice(instance.config.price, instance.calcWidth, instance.calcHeight) // 0?
        //   } else {
        //     return instance.config.price
        //   }
        // } else {
        //   let rooms = children.filter(item => item.config.type == 'room' && item.items.children.length > 0)
        //   let items = rooms.map(room => room.findItem(item.id)).filter(item => item)
        //   if (items.length > 0) {
        //     console.log(items[0].config.label.replace("\n", ' '))
        //     return items[0].config.price
        //   }
        // }
      })
    })
    let totalPrice = _.sum(_.flatten(priceArray))

    let getCalcVars = rootGetters['editor/getCalcVars']

    // 総床面積
    let allFloorSize = getters.allFloorArea
    if (allFloorSize == 0) return totalPrice

    let floorCount165 = new Decimal(allFloorSize).div(165).toNumber()
    // 1階床面積
    let floorSize1 = getters.getFloorArea(1)
    // 2階床面積
    let floorSize2 = getters.getFloorArea(2)
    // 3階床面積
    let floorSize3 = getters.getFloorArea(3)
    // 総屋根面積
    let allYaneSize = getters.allYaneSize
    // 外周長
    let gaisyuLength = getters.getGaisyuLength(1)
    // 階段数
    let stairNum = getters.allStairNum
    // 内壁面積
    let naihekiMenseki = getters.getNaihekiMenseki

    // 各明細費用
    let cost0101 = 0, cost0102 = 0, cost0103 = 0, cost0104 = 0, cost0105 = 0, cost0106 = 0, cost0107 = 0,
        cost0201 = 0, cost0202 = 0, cost0301 = 0, cost0302 = 0, cost0303 = 0, cost0401 = 0, cost0402 = 0,
        cost0501 = 0, cost0601 = 0, cost0602 = 0, cost0701 = 0, cost0702 = 0, cost0703 = 0, cost0801 = 0,
        cost0802 = 0, cost0803 = 0, cost0804 = 0, cost0901 = 0, cost0902 = 0, cost0903 = 0, cost1001 = 0,
        cost1002 = 0, cost1003 = 0, cost1011 = 0, cost1012 = 0, cost1013 = 0, cost1021 = 0, cost1022 = 0,
        cost1023 = 0, cost1024 = 0, cost1031 = 0, cost1041 = 0, cost1042 = 0, cost1101 = 0, cost1102 = 0,
        cost1103 = 0, cost1201 = 0, cost1202 = 0, cost1301 = 0, cost1302 = 0, cost1401 = 0, cost1501 = 0,
        cost1502 = 0, cost1601 = 0, cost1602 = 0, cost1701 = 0, cost1801 = 0

    // 各種変数
    let var030201 = 1, var030202 = 1, var050101 = 1, var060101 = 1, var060201 = 1,
        var100101 = 1, var100201 = 1, var100301 = 1, var101101 = 1, var101201 = 1,
        var101301 = 1, var102101 = 1, var102201 = 1, var102301 = 1,
        var102401 = 1, var110101 = 1, var110201 = 1, var110301 = 1, var120201 = 1,
        var140101 = 1, var150101 = 1, var150102 = 1, var150103 = 1

    if (allFloorSize < 99) {
      var030201 = getCalcVars("V", "N0302", "T1", "S1")
    } else if (allFloorSize < 165) {
      var030201 = getCalcVars("V", "N0302", "T1", "S2")
    } else {
      var030201 = getCalcVars("V", "N0302", "T1", "S3")
    }

    if (floorCount165 < 15) {
      var030202 = getCalcVars("V", "N0302", "T2", "S1")
    } else if (floorCount165 < 19) {
      var030202 = getCalcVars("V", "N0302", "T2", "S2")
    } else {
      var030202 = getCalcVars("V", "N0302", "T2", "S3")
    }

    if (state.roof_structure == 1) {
      var050101 = getCalcVars("V", "N0501", "T1", "S1")
    } else if (state.roof_structure == 2) {
      var050101 = getCalcVars("V", "N0501", "T1", "S2")
    } else if (state.roof_structure == 3) {
      var050101 = getCalcVars("V", "N0501", "T1", "S3")
    } else {
      var050101 = getCalcVars("V", "N0501", "T1", "S4")
    }

    if (state.roof_structure == 1) {
      var060101 = getCalcVars("V", "N0601", "T1", "S1")
      var060201 = getCalcVars("V", "N0602", "T1", "S1")
    } else if (state.roof_structure == 2) {
      var060101 = getCalcVars("V", "N0601", "T1", "S2")
      var060201 = getCalcVars("V", "N0602", "T1", "S2")
    } else if (state.roof_structure == 3) {
      var060101 = getCalcVars("V", "N0601", "T1", "S3")
      var060201 = getCalcVars("V", "N0602", "T1", "S3")
    } else {
      var060101 = getCalcVars("V", "N0601", "T1", "S4")
      var060201 = getCalcVars("V", "N0602", "T1", "S4")
    }

    if (state.interior_roof_finish == 1) {
      var100101 = getCalcVars("V", "N1001", "T1", "S1")
      var100201 = getCalcVars("V", "N1002", "T1", "S1")
      var100301 = getCalcVars("V", "N1003", "T1", "S1")
    } else if (state.interior_roof_finish == 2) {
      var100101 = getCalcVars("V", "N1001", "T1", "S2")
      var100201 = getCalcVars("V", "N1002", "T1", "S2")
      var100301 = getCalcVars("V", "N1003", "T1", "S2")
    } else if (state.interior_roof_finish == 3) {
      var100101 = getCalcVars("V", "N1001", "T1", "S3")
      var100201 = getCalcVars("V", "N1002", "T1", "S3")
      var100301 = getCalcVars("V", "N1003", "T1", "S3")
    } else if (state.interior_roof_finish == 4) {
      var100101 = getCalcVars("V", "N1001", "T1", "S4")
      var100201 = getCalcVars("V", "N1002", "T1", "S4")
      var100301 = getCalcVars("V", "N1003", "T1", "S4")
    } else {
      var100101 = getCalcVars("V", "N1001", "T1", "S5")
      var100201 = getCalcVars("V", "N1002", "T1", "S5")
      var100301 = getCalcVars("V", "N1003", "T1", "S5")
    }

    if (state.interior_wall_finish == 1) {
      var101101 = getCalcVars("V", "N1011", "T1", "S1")
      var101201 = getCalcVars("V", "N1012", "T1", "S1")
      var101301 = getCalcVars("V", "N1013", "T1", "S1")
    } else if (state.interior_wall_finish == 2) {
      var101101 = getCalcVars("V", "N1011", "T1", "S2")
      var101201 = getCalcVars("V", "N1012", "T1", "S2")
      var101301 = getCalcVars("V", "N1013", "T1", "S2")
    } else if (state.interior_wall_finish == 3) {
      var101101 = getCalcVars("V", "N1011", "T1", "S3")
      var101201 = getCalcVars("V", "N1012", "T1", "S3")
      var101301 = getCalcVars("V", "N1013", "T1", "S3")
    } else if (state.interior_wall_finish == 4) {
      var101101 = getCalcVars("V", "N1011", "T1", "S4")
      var101201 = getCalcVars("V", "N1012", "T1", "S4")
      var101301 = getCalcVars("V", "N1013", "T1", "S4")
    } else if (state.interior_wall_finish == 5) {
      var101101 = getCalcVars("V", "N1011", "T1", "S5")
      var101201 = getCalcVars("V", "N1012", "T1", "S5")
      var101301 = getCalcVars("V", "N1013", "T1", "S5")
    } else {
      var101101 = getCalcVars("V", "N1011", "T1", "S6")
      var101201 = getCalcVars("V", "N1012", "T1", "S6")
      var101301 = getCalcVars("V", "N1013", "T1", "S6")
    }

    if (state.interior_floor_finish == 1) {
      var102101 = getCalcVars("V", "N1021", "T1", "S1")
      var102201 = getCalcVars("V", "N1022", "T1", "S1")
      var102301 = getCalcVars("V", "N1023", "T1", "S1")
      var102401 = getCalcVars("V", "N1024", "T1", "S1")
    } else if (state.interior_floor_finish == 2) {
      var102101 = getCalcVars("V", "N1021", "T1", "S2")
      var102201 = getCalcVars("V", "N1022", "T1", "S2")
      var102301 = getCalcVars("V", "N1023", "T1", "S2")
      var102401 = getCalcVars("V", "N1024", "T1", "S2")
    } else if (state.interior_floor_finish == 3) {
      var102101 = getCalcVars("V", "N1021", "T1", "S3")
      var102201 = getCalcVars("V", "N1022", "T1", "S3")
      var102301 = getCalcVars("V", "N1023", "T1", "S3")
      var102401 = getCalcVars("V", "N1024", "T1", "S3")
    } else if (state.interior_floor_finish == 4) {
      var102101 = getCalcVars("V", "N1021", "T1", "S4")
      var102201 = getCalcVars("V", "N1022", "T1", "S4")
      var102301 = getCalcVars("V", "N1023", "T1", "S4")
      var102401 = getCalcVars("V", "N1024", "T1", "S4")
    } else if (state.interior_floor_finish == 5) {
      var102101 = getCalcVars("V", "N1021", "T1", "S5")
      var102201 = getCalcVars("V", "N1022", "T1", "S5")
      var102301 = getCalcVars("V", "N1023", "T1", "S5")
      var102401 = getCalcVars("V", "N1024", "T1", "S5")
    } else if (state.interior_floor_finish == 6) {
      var102101 = getCalcVars("V", "N1021", "T1", "S6")
      var102201 = getCalcVars("V", "N1022", "T1", "S6")
      var102301 = getCalcVars("V", "N1023", "T1", "S6")
      var102401 = getCalcVars("V", "N1024", "T1", "S6")
    } else {
      var102101 = getCalcVars("V", "N1021", "T1", "S7")
      var102201 = getCalcVars("V", "N1022", "T1", "S7")
      var102301 = getCalcVars("V", "N1023", "T1", "S7")
      var102401 = getCalcVars("V", "N1024", "T1", "S7")
    }

    if (state.interior_roof_finish == 1) {
      var110101 = getCalcVars("V", "N1101", "T1", "S1")
    } else if (state.interior_roof_finish == 2) {
      var110101 = getCalcVars("V", "N1101", "T1", "S2")
    } else if (state.interior_roof_finish == 3) {
      var110101 = getCalcVars("V", "N1101", "T1", "S3")
    } else if (state.interior_roof_finish == 4) {
      var110101 = getCalcVars("V", "N1101", "T1", "S4")
    } else {
      var110101 = getCalcVars("V", "N1101", "T1", "S5")
    }
    if (state.interior_wall_finish == 1) {
      var110201 = getCalcVars("V", "N1102", "T1", "S1")
    } else if (state.interior_wall_finish == 2) {
      var110201 = getCalcVars("V", "N1102", "T1", "S2")
    } else if (state.interior_wall_finish == 3) {
      var110201 = getCalcVars("V", "N1102", "T1", "S3")
    } else if (state.interior_wall_finish == 4) {
      var110201 = getCalcVars("V", "N1102", "T1", "S4")
    } else if (state.interior_wall_finish == 5) {
      var110201 = getCalcVars("V", "N1102", "T1", "S5")
    } else {
      var110201 = getCalcVars("V", "N1102", "T1", "S6")
    }
    if (state.interior_floor_finish == 1) {
      var110301 = getCalcVars("V", "N1103", "T1", "S1")
    } else if (state.interior_floor_finish == 2) {
      var110301 = getCalcVars("V", "N1103", "T1", "S2")
    } else if (state.interior_floor_finish == 3) {
      var110301 = getCalcVars("V", "N1103", "T1", "S3")
    } else if (state.interior_floor_finish == 4) {
      var110301 = getCalcVars("V", "N1103", "T1", "S4")
    } else if (state.interior_floor_finish == 5) {
      var110301 = getCalcVars("V", "N1103", "T1", "S5")
    } else if (state.interior_floor_finish == 6) {
      var110301 = getCalcVars("V", "N1103", "T1", "S6")
    } else {
      var110301 = getCalcVars("V", "N1103", "T1", "S7")
    }

    if (state.floor_heating_facility == 1) {
      var120201 = getCalcVars("V", "N1202", "T1", "S1")
    } else if (state.floor_heating_facility == 2) {
      var120201 = getCalcVars("V", "N1202", "T1", "S2")
    } else if (state.floor_heating_facility == 3) {
      var120201 = getCalcVars("V", "N1202", "T1", "S3")
    } else {
      var120201 = getCalcVars("V", "N1202", "T1", "S4")
    }

    if (allFloorSize < 99) {
      var140101 = getCalcVars("V", "N1401", "T1", "S1")
    } else if (allFloorSize < 165) {
      var140101 = getCalcVars("V", "N1401", "T1", "S2")
    } else {
      var140101 = getCalcVars("V", "N1401", "T1", "S3")
    }

    var150101 = 1
    var150102 = 1
    var150103 = 1

    // 0101:電力用水費
    if (state.insulation_material == 1) {
      cost0101 = getCalcVars("V", "N0101", "P", "S4")
    } else if (allFloorSize < 99) {
      cost0101 = getCalcVars("V", "N0101", "P", "S1")
    } else if (allFloorSize < 165) {
      cost0101 = getCalcVars("V", "N0101", "P", "S2")
    } else {
      cost0101 = getCalcVars("V", "N0101", "P", "S3")
    }
    cost0101 = new Decimal(cost0101).mul(getCalcVars("C", "N0101", "T1")).toNumber()

    // 0102:仮設トイレ費
    if (allFloorSize < 165) {
      cost0102 = getCalcVars("V", "N0102", "P", "S1")
    } else {
      cost0102 = getCalcVars("V", "N0102", "P", "S2")
    }
    cost0102 = new Decimal(cost0102).mul(getCalcVars("C", "N0102", "T1")).toNumber()

    // 0103:養生・清掃費
    cost0103 = new Decimal(allFloorSize).mul(getCalcVars("C", "N0103", "P")).toNumber()

    // 0104:ｸﾘｰﾆﾝｸﾞ
    cost0104 = new Decimal(allFloorSize).mul(getCalcVars("C", "N0104", "P")).toNumber()

    // 0105:足場
    cost0105 = new Decimal(allFloorSize).mul(getCalcVars("C", "N0105", "P")).toNumber()

    // 0106:仮囲い
    cost0106 = new Decimal(allFloorSize).mul(getCalcVars("C", "N0106", "P")).toNumber()

    // 0107:残材処理
    cost0107 = new Decimal(allFloorSize).mul(getCalcVars("C", "N0107", "P")).toNumber()

    // 0201:コンクリートＰ費
    if (allFloorSize < 99) {
      cost0201 = getCalcVars("V", "N0201", "P", "S1")
    } else if (allFloorSize < 198) {
      cost0201 = getCalcVars("V", "N0201", "P", "S2")
    } else {
      cost0201 = getCalcVars("V", "N0201", "P", "S3")
    }
    cost0201 = new Decimal(cost0201).mul(getCalcVars("C", "N0201", "T1")).toNumber()

    // 0202:基礎工事全般
    cost0202 = new Decimal(floorSize1).mul(getCalcVars("C", "N0202", "P")).toNumber()

    // 0301:木材構造材費
    if (state.pillar_material == 1) {
      cost0301 = getCalcVars("V", "N0301", "P", "S1")
    } else if (state.pillar_material == 2) {
      cost0301 = getCalcVars("V", "N0301", "P", "S2")
    } else if (state.pillar_material == 3) {
      cost0301 = getCalcVars("V", "N0301", "P", "S3")
    } else if (state.pillar_material == 4) {
      cost0301 = getCalcVars("V", "N0301", "P", "S4")
    } else {
      cost0301 = getCalcVars("V", "N0301", "P", "S5")
    }
    cost0301 = new Decimal(cost0301).mul(allFloorSize).toNumber()

    // 0302:木材造作材費
    if (state.pillar_material == 1) {
      cost0302 = getCalcVars("V", "N0302", "P", "S1")
    } else if (state.pillar_material == 2) {
      cost0302 = getCalcVars("V", "N0302", "P", "S2")
    } else if (state.pillar_material == 3) {
      cost0302 = getCalcVars("V", "N0302", "P", "S3")
    } else if (state.pillar_material == 4) {
      cost0302 = getCalcVars("V", "N0302", "P", "S4")
    } else {
      cost0302 = getCalcVars("V", "N0302", "P", "S5")
    }
    cost0302 = new Decimal(cost0302).mul(allFloorSize).mul(var030201).mul(var030202).toNumber()

    // 0303:剛床材料費
    cost0303 = new Decimal(getCalcVars("C", "N0303", "P")).mul(new Decimal(allFloorSize).sub(floorSize1)).toNumber()

    // 0401:クレーンやり方費
    if (allFloorSize < 99) {
      cost0401 = getCalcVars("V", "N0401", "P", "S1")
    } else if (allFloorSize < 198) {
      cost0401 = getCalcVars("V", "N0401", "P", "S2")
    } else {
      cost0401 = getCalcVars("V", "N0401", "P", "S3")
    }
    cost0401 = new Decimal(cost0401).mul(getCalcVars("C", "N0401", "T1")).toNumber()

    // 0402:建前全般費
    cost0402 = new Decimal(getCalcVars("C", "N0402", "P")).mul(allFloorSize).toNumber()

    // 0501:外壁費
    if (state.exterior_wall_material == 1) {
      cost0501 = getCalcVars("V", "N0501", "P", "S1")
    } else if (state.exterior_wall_material == 2) {
      cost0501 = getCalcVars("V", "N0501", "P", "S2")
    } else if (state.exterior_wall_material == 3) {
      cost0501 = getCalcVars("V", "N0501", "P", "S3")
    } else if (state.exterior_wall_material == 4) {
      cost0501 = getCalcVars("V", "N0501", "P", "S4")
    } else {
      cost0501 = getCalcVars("V", "N0501", "P", "S5")
    }
    cost0501 = new Decimal(cost0501).mul(allFloorSize).mul(var050101).toNumber()

    // 0601:屋根費
    if (state.exterior_roof_material == 1) {
      cost0601 = getCalcVars("V", "N0601", "P", "S1")
    } else if (state.exterior_roof_material == 2) {
      cost0601 = getCalcVars("V", "N0601", "P", "S2")
    } else if (state.exterior_roof_material == 3) {
      cost0601 = getCalcVars("V", "N0601", "P", "S3")
    } else if (state.exterior_roof_material == 4) {
      cost0601 = getCalcVars("V", "N0601", "P", "S4")
    } else {
      cost0601 = getCalcVars("V", "N0601", "P", "S5")
    }
    cost0601 = new Decimal(cost0601).mul(allYaneSize).mul(var060101).toNumber()

    // 0602:屋根左官費
    if (state.exterior_roof_material == 1) {
      cost0602 = getCalcVars("V", "N0602", "P", "S1")
    } else if (state.exterior_roof_material == 2) {
      cost0602 = getCalcVars("V", "N0602", "P", "S2")
    } else if (state.exterior_roof_material == 3) {
      cost0602 = getCalcVars("V", "N0602", "P", "S3")
    } else if (state.exterior_roof_material == 4) {
      cost0602 = getCalcVars("V", "N0602", "P", "S4")
    } else {
      cost0602 = getCalcVars("V", "N0602", "P", "S5")
    }
    cost0602 = new Decimal(cost0602).mul(getCalcVars("C", "N0602", "T1")).mul(var060201).toNumber()

    // 0701:巾木塗り費
    cost0701 = new Decimal(getCalcVars("C", "N0701", "P")).mul(gaisyuLength).toNumber()

    // 0702:犬走り費
    cost0702 = new Decimal(getCalcVars("C", "N0702", "P")).mul(gaisyuLength).mul(getCalcVars("C", "N0702", "T2")).toNumber()

    // 0703:玄関左官費
    cost0703 = new Decimal(getCalcVars("C", "N0703", "P")).toNumber()

    // 0801:階段１
    cost0801 = new Decimal(getCalcVars("C", "N0801", "P")).mul(stairNum).toNumber()

    // 以下の設備の集計費用はpriceInfoArrayで集計済み
    // 0802:ドア集計
    // 0803:窓集計
    // 0804:作り付け家具集計
    // 0901:トイレ集計
    // 0902:流し台集計
    // 0903:手洗い集計

    // 1001:天井国産材
    cost1001 = new Decimal(getCalcVars("C", "N1001", "P")).mul(allFloorSize).mul(var150102).mul(var100101).toNumber()

    // 1002:天井クロス
    cost1002 = new Decimal(getCalcVars("C", "N1002", "P")).mul(allFloorSize).mul(var150102).mul(var100201).toNumber()

    // 1003:天井珪藻土
    cost1003 = new Decimal(getCalcVars("C", "N1003", "P")).mul(allFloorSize).mul(var150102).mul(var100301).toNumber()

    // 1011:壁国産材
    cost1011 = new Decimal(getCalcVars("C", "N1011", "P")).mul(naihekiMenseki).mul(var150103).mul(var101101).toNumber()

    // 1012:壁クロス
    cost1012 = new Decimal(getCalcVars("C", "N1012", "P")).mul(naihekiMenseki).mul(var150103).mul(var101201).toNumber()

    // 1013:壁珪藻土
    cost1013 = new Decimal(getCalcVars("C", "N1013", "P")).mul(naihekiMenseki).mul(var150103).mul(var101301).toNumber()

    // 1021:床国産材
    cost1021 = new Decimal(getCalcVars("C", "N1021", "P")).mul(allFloorSize).mul(var150102).mul(var102101).toNumber()

    // 1022:床合板
    cost1022 = new Decimal(getCalcVars("C", "N1022", "P")).mul(allFloorSize).mul(var150102).mul(var102201).toNumber()

    // 1023:床クッションフロアー
    cost1023 = new Decimal(getCalcVars("C", "N1023", "P")).mul(allFloorSize).mul(var150102).mul(var102301).toNumber()

    // 1024:床畳
    cost1024 = new Decimal(getCalcVars("C", "N1024", "P")).mul(allFloorSize).mul(var150102).mul(var102401).toNumber()

    // 1031:巾木周木
    cost1031 = new Decimal(getCalcVars("C", "N1031", "P")).mul(allFloorSize).mul(var150102).toNumber()

    // 1041:断熱材床
    cost1041 = new Decimal(getCalcVars("C", "N1041", "P")).mul(floorSize1).mul(var150101).toNumber()

    // 1042:断熱材壁
    if (state.insulation_material == 1) {
      cost1042 = getCalcVars("V", "N1042", "P", "S1")
    } else if (state.insulation_material == 2) {
      cost1042 = getCalcVars("V", "N1042", "P", "S2")
    } else if (state.insulation_material == 3) {
      cost1042 = getCalcVars("V", "N1042", "P", "S3")
    } else {
      cost1042 = getCalcVars("V", "N1042", "P", "S4")
    }
    cost1042 = new Decimal(cost1042).mul(naihekiMenseki).mul(var150103).mul(getCalcVars("C", "N1042", "T3")).toNumber()

    // 1101:天井塗装工事
    // 1102:壁塗装工事
    // 1103:床塗装工事
    cost1101 = new Decimal(getCalcVars("C", "N1101", "P")).mul(allFloorSize).mul(var150102).mul(var110101).toNumber()
    cost1102 = new Decimal(getCalcVars("C", "N1102", "P")).mul(naihekiMenseki).mul(var150103).mul(var110201).toNumber()
    cost1103 = new Decimal(getCalcVars("C", "N1103", "P")).mul(allFloorSize).mul(var150102).mul(var110301).toNumber()

    // 1201:床暖房工事固定費
    // 1202:床暖房面工事
    if (var120201 > 0) {
      cost1201 = new Decimal(getCalcVars("C", "N1201", "P")).mul(getCalcVars("C", "N1201", "T1")).toNumber()
      cost1202 = new Decimal(getCalcVars("C", "N1202", "P")).mul(allFloorSize).mul(var150102).mul(var120201).toNumber()
    }

    // 1301:電気工事基本額
    cost1301 = new Decimal(getCalcVars("C", "N1301", "P")).mul(getCalcVars("C", "N1301", "T1")).toNumber()

    // 1302:電気工事流動額
    cost1302 = new Decimal(getCalcVars("C", "N1302", "P")).mul(allFloorSize).mul(var150102).toNumber()

    // 1401:給排水工事
    cost1401 = new Decimal(getCalcVars("C", "N1401", "P")).mul(getCalcVars("C", "N1401", "T1")).mul(var140101).toNumber()

    // 1501:シロアリ防虫費
    cost1501 = new Decimal(getCalcVars("C", "N1501", "P")).mul(new Decimal(floorSize1).plus(var150101)).toNumber()

    // 1502:バリアフリー
    if (state.natural_energy_facility == 1) {
      cost1502 = getCalcVars("V", "N1502", "P", "S1")
    } else if (state.natural_energy_facility == 2) {
      cost1502 = getCalcVars("V", "N1502", "P", "S2")
    } else if (state.natural_energy_facility == 3) {
      cost1502 = getCalcVars("V", "N1502", "P", "S3")
    } else {
      cost1502 = getCalcVars("V", "N1502", "P", "S4")
    }

    // 1601:固定諸経費
    // 1602:流動諸経費
    cost1601 = new Decimal(getCalcVars("C", "N1601", "P")).mul(getCalcVars("C", "N1601", "T1")).toNumber()
    cost1602 = new Decimal(getCalcVars("C", "N1602", "P")).mul(allFloorSize).mul(var150102).toNumber()

    // 1701:エコキュート
    if (state.hot_water_supply_facility == 1) {
      cost1701 = getCalcVars("C", "N1701", "P")
    }

    // 1801:抗花粉設備
    if (state.anti_pollen_facility == 1) {
      cost1801 = getCalcVars("V", "N1801", "P", "S1")
    } else if (state.anti_pollen_facility == 2) {
      cost1801 = getCalcVars("V", "N1801", "P", "S2")
    } else if (state.anti_pollen_facility == 3) {
      cost1801 = getCalcVars("V", "N1801", "P", "S3")
    } else {
      cost1801 = getCalcVars("V", "N1801", "P", "S4")
    }

    // console.info("建築仕様設定")
    // console.log([
    //   state.options.pillar_material.find(s => s.value == state.pillar_material).label,
    //   state.options.roof_structure.find(s => s.value == state.roof_structure).label,
    //   state.options.insulation_material.find(s => s.value == state.insulation_material).label,
    //   state.options.exterior_wall_material.find(s => s.value == state.exterior_wall_material).label,
    //   state.options.exterior_roof_material.find(s => s.value == state.exterior_roof_material).label,
    //   state.options.interior_roof_finish.find(s => s.value == state.interior_roof_finish).label,
    //   state.options.interior_wall_finish.find(s => s.value == state.interior_wall_finish).label,
    //   state.options.interior_floor_finish.find(s => s.value == state.interior_floor_finish).label,
    //   state.options.anti_pollen_facility.find(s => s.value == state.anti_pollen_facility).label,
    //   state.options.natural_energy_facility.find(s => s.value == state.natural_energy_facility).label,
    //   state.options.floor_heating_facility.find(s => s.value == state.floor_heating_facility).label,
    //   state.options.hot_water_supply_facility.find(s => s.value == state.hot_water_supply_facility).label,
    // ].join("\n"))

    // console.info("配置アイテム")
    // console.log(itemList.join("\n"))

    // console.info("各面積")
    // console.log([floorSize1, floorSize2, floorSize3, floorCount165, allFloorSize, naihekiMenseki, gaisyuLength, allYaneSize].join("\n"))

    // console.info("計算結果 JSの結果")
    // console.log([
    //   cost0101, cost0102, cost0103, cost0104, cost0105, cost0106, cost0107,
    //   cost0201, cost0202, cost0301, cost0302, cost0303, cost0401, cost0402,
    //   cost0501, cost0601, cost0602, cost0701, cost0702, cost0703, cost0801,
    //   totalPrice,　'', '', '', '', '', cost1001,
    //   cost1002, cost1003, cost1011, cost1012, cost1013, cost1021, cost1022,
    //   cost1023, cost1024, cost1031, cost1041, cost1042, cost1101, cost1102,
    //   cost1103, cost1201, cost1202, cost1301, cost1302, cost1401, cost1501,
    //   cost1502, cost1601, cost1602, cost1701, cost1801
    // ].join("\n"))

    // console.info("変数 JSの値")
    // console.log([
    //   var030201, var030202, var050101, var060101, var060201,
    //   var100101, var100201, var100301, var101101, var101201,
    //   var101301, var102101, var102201, var102301,
    //   var102401, var110101, var110201, var110301, var120201,
    //   var140101, var150101, var150102, var150103
    // ].join("\n"))
    return Math.floor(
      totalPrice
      + cost0101 + cost0102 + cost0103 + cost0104 + cost0105 + cost0106 + cost0107
      + cost0201 + cost0202 + cost0301 + cost0302 + cost0303 + cost0401 + cost0402
      + cost0501 + cost0601 + cost0602 + cost0701 + cost0702 + cost0703 + cost0801
      + cost0802 + cost0803 + cost0804 + cost0901 + cost0902 + cost0903 + cost1001
      + cost1002 + cost1003 + cost1011 + cost1012 + cost1013 + cost1021 + cost1022
      + cost1023 + cost1024 + cost1031 + cost1041 + cost1042 + cost1101 + cost1102
      + cost1103 + cost1201 + cost1202 + cost1301 + cost1302 + cost1401 + cost1501
      + cost1502 + cost1601 + cost1602 + cost1701 + cost1801
     )
  },
  tanso(state, getters) {
    let tanso = 
      0.25 
      * 0.18
      * getters.allFloorArea
      * getters.tanso0101
      * getters.tanso0102
      * getters.tanso0103
      * getters.tanso0201
      * getters.tanso0202
      * getters.tanso0203

    if (tanso >= 100) {
      tanso = 99.99
    }
    return _.floor(tanso * 100) / 100
  },
  tanso0101(state) {
    let option = state.options.pillar_material.find(option => option.value == state.pillar_material)
    return option ? option.tanso : 1
  },
  tanso0102(state, getters) {
    let floorCount165 = new Decimal(getters.allFloorArea).div(165).toNumber()
    if (floorCount165 < 15) {
      return 0.98
    } else if (floorCount165 < 19) {
      return 1.00
    } else {
      return 1.02
    }
  },
  tanso0103(state) {
    let option = state.options.roof_structure.find(option => option.value == state.roof_structure)
    return option ? option.tanso : 1
  },
  tanso0201(state) {
    let option = state.options.interior_roof_finish.find(option => option.value == state.interior_roof_finish)
    return option ? option.tanso : 1
  },
  tanso0202(state) {
    let option = state.options.interior_wall_finish.find(option => option.value == state.interior_wall_finish)
    return option ? option.tanso : 1
  },
  tanso0203(state) {
    let option = state.options.interior_floor_finish.find(option => option.value == state.interior_floor_finish)
    return option ? option.tanso : 1
  },
}

const actions = {
  gridSettled({ commit }) {
    commit('gridSettled')
  },
  fetchRemoteSavedata({ commit, rootGetters }, id) {
    return axios.request({
        url: '/apis/loadItemData',
        method: 'get',
        headers: { 'Accept-Language': 'ja,en-US;q=0.9,en;q=0.8' },
        params: { savedata_id: id },
        responseType: 'json',
      })
      .then(response => {
        let { savedata_info, item_save_data, specifications, is_own } = response.data
        let state = {}

        // 間取り情報
        state.id                  = parseInt(savedata_info.id)
        state.title               = savedata_info.title || state.title
        state.nick_name           = savedata_info.nick_name
        state.display_count       = parseInt(savedata_info.display_count)
        state.first_floor_space   = parseFloat(savedata_info.first_floor_space)
        state.price               = parseInt(savedata_info.price)
        state.prized              = savedata_info.prized
        state.prize_updated       = savedata_info.prize_updated
        state.tanso               = parseFloat(savedata_info.tanso)
        state.order_no            = parseInt(savedata_info.order_no)
        state.architect_comment   = savedata_info.architect_comment
        state.architect_id        = parseInt(savedata_info.architect_id)
        state.public              = savedata_info.public
        state.deleted             = parseDate(savedata_info.deleted)
        state.created             = parseDate(savedata_info.created)
        state.modified            = parseDate(savedata_info.modified)

        // 配置アイテム
        if (item_save_data) {
          state.items = Object.keys(item_save_data).map(floor => item_save_data[floor].map(item => {
            if (item.matrix_create_box_data.rotation == 166) {
              item.matrix_create_box_data.rotation = 270
            }
            if (item.matrix_create_box_data.scale_x == 4294967295) {
              item.matrix_create_box_data.scale_x = -1
            }
            if (item.matrix_create_box_data.scale_y == 4294967295) {
              item.matrix_create_box_data.scale_y = -1
            }
            if (item.matrix_create_box_data.rotation < 0) {
              item.matrix_create_box_data.rotation = 360 + parseInt(item.matrix_create_box_data.rotation)
            }
            if (item.sim_parent_id == 0) {
              return {
                id: parseInt(item.sim_uniq_id),
                parent_id: parseInt(item.sim_parent_id),
                floor: parseInt(item.floor_level) + 1,
                config_id: parseInt(item.item_conf_id),
                x: parseInt(item.matrix_create_box_data.tx) / grid.cellSize - 1,
                y: parseInt(item.matrix_create_box_data.ty) / grid.cellSize - 1,
                width: parseFloat(item.matrix_create_box_data.scale_x) * grid.division,
                height: parseFloat(item.matrix_create_box_data.scale_y) * grid.division,
                rotation: Math.round(parseInt(item.matrix_create_box_data.rotation) / 90) * 90,
              }
            } else {
              return {
                id: parseInt(item.sim_uniq_id),
                parent_id: parseInt(item.sim_parent_id),
                floor: parseInt(item.floor_level) + 1,
                config_id: parseInt(item.item_conf_id),
                x: parseInt(item.matrix_create_box_data.tx) / grid.cellSize,
                y: parseInt(item.matrix_create_box_data.ty) / grid.cellSize,
                width: parseFloat(item.matrix_create_box_data.scale_x) * 2,
                height: parseFloat(item.matrix_create_box_data.scale_y) * 2,
                rotation: Math.round(parseInt(item.matrix_create_box_data.rotation) / 90) * 90,
              }
            }
          }).filter(i => i))
        }

        // 建物仕様設定
        state.spec_selected = true
        if (specifications.length > 0) {
          if (specifications[0])  state.spec_format               = parseInt(specifications[0])
          if (specifications[1])  state.pillar_material           = parseInt(specifications[1])
          if (specifications[2])  state.roof_structure            = parseInt(specifications[2])
          if (specifications[3])  state.insulation_material       = parseInt(specifications[3])
          if (specifications[4])  state.exterior_wall_material    = parseInt(specifications[4])
          if (specifications[5])  state.exterior_roof_material    = parseInt(specifications[5])
          if (specifications[6])  state.interior_roof_finish      = parseInt(specifications[6])
          if (specifications[7])  state.interior_wall_finish      = parseInt(specifications[7])
          if (specifications[8])  state.interior_floor_finish     = parseInt(specifications[8])
          if (specifications[9])  state.anti_pollen_facility      = parseInt(specifications[9])
          if (specifications[10]) state.natural_energy_facility   = parseInt(specifications[10])
          if (specifications[11]) state.floor_heating_facility    = parseInt(specifications[11])
          if (specifications[12]) state.hot_water_supply_facility = parseInt(specifications[12])
        }

        state.is_own = is_own

        commit('setSavedata', state)
      })
  },
  updateTitle({ commit }, value) {
    commit('updateTitle', value)
  },
  updatePublic({ commit }, value) {
    commit('updatePublic', value)
  },
  updateSpecSelected({ commit }, value) {
    commit('updateSpecSelected', value)
  },
  updateSpecFormat({ commit }, value) {
    commit('updateSpecFormat', value)
  },
  updatePillarMaterial({ commit }, value) {
    commit('updatePillarMaterial', value)
  },
  updateRoofStructure({ commit }, value) {
    commit('updateRoofStructure', value)
  },
  updateInsulationMaterial({ commit }, value) {
    commit('updateInsulationMaterial', value)
  },
  updateExteriorWallMaterial({ commit }, value) {
    commit('updateExteriorWallMaterial', value)
  },
  updateExteriorRoofMaterial({ commit }, value) {
    commit('updateExteriorRoofMaterial', value)
  },
  updateInteriorRoofFinish({ commit }, value) {
    commit('updateInteriorRoofFinish', value)
  },
  updateInteriorWallFinish({ commit }, value) {
    commit('updateInteriorWallFinish', value)
  },
  updateInteriorFloorFinish({ commit }, value) {
    commit('updateInteriorFloorFinish', value)
  },
  updateAntiPollenFacility({ commit }, value) {
    commit('updateAntiPollenFacility', value)
  },
  updateNaturalEnergyFacility({ commit }, value) {
    commit('updateNaturalEnergyFacility', value)
  },
  updateFloorHeatingFacility({ commit }, value) {
    commit('updateFloorHeatingFacility', value)
  },
  updateHotWaterSupplyFacility({ commit }, value) {
    commit('updateHotWaterSupplyFacility', value)
  },
  addItem({ commit, dispatch, rootState }, { config, item }) {
    // 階
    let floor = rootState.editor.floor
    if (item) {
      floor = item.floor
    }

    // 配置アイテム
    const instance = config.type == 'room' ? new Room(config, item) : new Item(config, item)

    let floorLayer = grid.getFloor(floor)
    let floorLabelLayer = grid.getFloorLabel(floor)
    let floorFloorLayer = grid.getFloorFloor(floor)
    let parent = null
    if (instance instanceof Item && item && item.parent_id > 0) {
      parent = floorLayer.children.find(child => child instanceof Room && child.id == item.parent_id)
    }
    if (parent) {
      parent.items.addChild(instance)
    } else {
      floorLayer.addChild(instance)
    }

    if (instance.floor) {
      floorFloorLayer.addChild(instance.floor)
    }

    if (instance.label) {
      floorLabelLayer.addChild(instance.label)
    }

    let inspectorUpdate = () => {
      if (instance.config.type == 'room') {
        dispatch('editor/inspect', {
          config: instance.config,
          width: instance.dimension.x * grid.shaku3 * 1000,
          height: instance.dimension.y * grid.shaku3 * 1000,
        }, { root: true })
      } else {
        dispatch('editor/inspect', {
          config: instance.config,
          // width: instance.angle % 180 == 0 ? config.catalog.width : config.catalog.height,
          // height: instance.angle % 180 != 0 ? config.catalog.width : config.catalog.height,
        }, { root: true })
      }
    }

    // フォーカス時
    instance.on('focus', () => {
      instance.on('updatedimension', inspectorUpdate)
      inspectorUpdate()

      // 先にアクティブレイヤーのRoom instanceをblur
      grid.activeLayer.children.filter(activeInstance => {
        return (activeInstance instanceof Room || activeInstance instanceof Item) && activeInstance.id != instance.id
      }).forEach(activeInstance => activeInstance.blur())

      // 床をアクティブレイヤーへ移動
      if (instance.floor) {
        instance.floor.setParent(grid.activeLayer)
      }

      // instanceをアクティブレイヤーへ移動
      if (instance.room) {
        instance.coordinate.set(instance.coordinate.x + instance.room.coordinate.x, instance.coordinate.y + instance.room.coordinate.y)
        instance.setParent(grid.activeLayer)
      } else {
        instance.setParent(grid.activeLayer)
      }

      // ラベルをアクティブレイヤーへ移動
      if (instance.label) {
        instance.label.setParent(grid.activeLayer)
      }

      // コントローラーをアクティブレイヤーに追加
      grid.activeLayer.addChild(instance.controller)

      grid.updateArea()
    })

    instance.on('blur', () => {
      instance.off('updatedimension', inspectorUpdate)

      // 床をフロア床レイヤーへ移動
      if (instance.floor) {
        instance.floor.setParent(floorFloorLayer)
      }

      // instanceをフロアレイヤーへ移動
      if (instance.config.type == 'room') {
        instance.setParent(floorLayer)
      } else {
        // 重なるroomを探して見つかったらroomに入れる
        let room = floorLayer.children
          .filter(child => child.config.type == 'room')
          .find(room => {
            let leftTop = new Point()
            let rightBottom = new Point()

            // doorの時はareaの上辺から1div分が含まれるか
            if (instance.config.type == 'door') {
              let div = grid.size / grid.division
              let angle = instance.angle
              if (instance.dimension.y < 0) {
                if (angle == 0) angle = 180
                else if (angle == 180) angle = 0
                else if (angle == 90) angle = 270
                else if (angle == 270) angle = 90
              }
              switch (angle) {
                case 0:
                  leftTop.set(instance.position.x, instance.position.y)
                  rightBottom.set(instance.position.x + instance.calcWidth, instance.position.y + div)
                  break
                case 90:
                  leftTop.set(instance.position.x + instance.calcWidth - div, instance.position.y)
                  rightBottom.set(instance.position.x + instance.calcWidth, instance.position.y + instance.calcHeight)
                  break
                case 180:
                  leftTop.set(instance.position.x, instance.position.y + instance.calcHeight - div)
                  rightBottom.set(instance.position.x + instance.calcWidth, instance.position.y + instance.calcHeight)
                  break
                case 270:
                  leftTop.set(instance.position.x, instance.position.y)
                  rightBottom.set(instance.position.x + div, instance.position.y + instance.calcHeight)
                  break
              }
            } else {
              leftTop.set(instance.position.x, instance.position.y)
              rightBottom.set(instance.position.x + instance.calcWidth, instance.position.y + instance.calcHeight)
            }
            return room.position.x <= leftTop.x && rightBottom.x <= room.position.x + room.floor.width
                && room.position.y <= leftTop.y && rightBottom.y <= room.position.y + room.floor.height
          })

        if (room) {
          instance.setParent(room.items)
          instance.coordinate.set(instance.coordinate.x - room.coordinate.x, instance.coordinate.y - room.coordinate.y)
        } else {
          instance.setParent(floorLayer)
        }
      }

      // ラベルをフロアラベルレイヤーへ移動
      if (instance.label) {
        instance.label.setParent(floorLabelLayer)
      }

      // コントローラーを取り除く
      if (instance.controller) {
        grid.activeLayer.removeChild(instance.controller)
      }

      commit('updateItem', {
        id: instance.id,
        parent_id: instance.room ? instance.room.id : null,
        floor: floor,
        config_id: instance.config.id,
        x: instance.coordinate.x,
        y: instance.coordinate.y,
        width: instance.dimension.x,
        height: instance.dimension.y,
        rotation: instance.angle,
      })

      grid.updateArea()
    })

    // つかんだ
    instance.on('grab', () => {
      dispatch('item/setItemShadowConfig', instance.config, { root: true })
    })

    // はなした
    instance.on('drop', () => {
      dispatch('item/hideItemShadow', null, { root: true })
      dispatch('item/unsetItemShadowConfig', null, { root: true })
    })

    // エリア外にドロップ
    instance.on('dropout', () => {
      instance.destroy()
      commit('removeItem', {
        id: instance.id,
        floor: floor,
      })
    })

    // 削除
    instance.on('trash', () => {
      instance.destroy()
      commit('removeItem', {
        id: instance.id,
        floor: floor,
      })
    })

    return instance
  },
  removeItem({ commit }, payload) {
    commit('removeItem', payload)
  },
  updateItem({ commit }, payload) {
    commit('updateItem', payload)
  },
  postSaveItemData({ commit, state, getters, rootState }, { png_images, copy }) {
    let items = []
    for (let floor of [0,1,2]) {
      let children = grid.getFloor(floor+1).children
      if (children.length > 0) {
        children.forEach(child => {
          items.push({
            matrix_create_box_data: {
              tx: (child.coordinate.x + 1) * grid.cellSize,
              ty: (child.coordinate.y + 1) * grid.cellSize,
              rotation: child.angle,
              ...(child instanceof Room ? {
                scale_x: child.dimension.x / grid.division,
                scale_y: child.dimension.y / grid.division,
              } : {
                scale_x: child.dimension.x > 0 ? 1 : -1,
                scale_y: child.dimension.y > 0 ? 1 : -1,
              } )
            },
            sim_uniq_id: child.id,
            sim_parent_id: 0,
            floor_level: floor,
            item_conf_id: child.config.id,
          })
          if (child instanceof Room) {
            if (child.items.children.length > 0) {
              child.items.children.forEach(item => {
                items.push({
                  matrix_create_box_data: {
                    tx: item.coordinate.x * grid.cellSize,
                    ty: item.coordinate.y * grid.cellSize,
                    rotation: item.angle,
                    ...(item instanceof Room ? {
                      scale_x: item.dimension.x / grid.division,
                      scale_y: item.dimension.y / grid.division,
                    } : {
                      scale_x: item.dimension.x > 0 ? 1 : -1,
                      scale_y: item.dimension.y > 0 ? 1 : -1,
                    } )
                  },
                  sim_uniq_id: item.id,
                  sim_parent_id: child.id,
                  floor_level: floor,
                  item_conf_id: item.config.id,
                })
              })
            }
          }
        })
      }
    }
    return axios.request({
        url: '/apis/saveItemData',
        method: 'post',
        headers: { 'Accept-Language': 'ja,en-US;q=0.9,en;q=0.8' },
        data: {
          item_save_data: items,
          specifications: [
            state.spec_format,
            state.pillar_material,
            state.roof_structure,
            state.insulation_material,
            state.exterior_wall_material,
            state.exterior_roof_material,
            state.interior_roof_finish,
            state.interior_wall_finish,
            state.interior_floor_finish,
            state.anti_pollen_facility,
            state.natural_energy_facility,
            state.floor_heating_facility,
            state.hot_water_supply_facility,
          ],
          title: state.title,
          public_flg: state.public,
          member_id: rootState.member ? rootState.member.id : null,
          madorisim_savedata_id: copy ? null : state.id,
          png_images: png_images.map(png_image => png_image.replace('data:image/png;base64,', '')),
          first_floor_space: getters.getFloorArea(1),
          price: getters.price,
          floor_num: state.items.filter(items => items.length > 0).length,
          tanso: getters.tanso,
        },
        responseType: 'json',
      })
      .then(response => {
        let { savedata_id } = response.data
        // commit('updateSaveDataId', savedata_id)
        return savedata_id
      })
  },
  postSavePrintImages({ commit, state, getters, rootState }, { png_images }) {
    return axios.request({
        url: '/apis/savePrintImages',
        method: 'post',
        headers: { 'Accept-Language': 'ja,en-US;q=0.9,en;q=0.8' },
        data: {
          png_images: png_images.map(png_image => png_image.replace('data:image/png;base64,', '')),
        },
        responseType: 'json',
      })
      .then(response => {
        // let { dirname } = response.data
        return {
          name: state.title,
          totalPrice: getters.price,
          totalSize: getters.allFloorArea,
          totalSizeTubo: getters.allFloorTsubo,
          f1Size: getters.getFloorArea(1),
          f1SizeTubo: getters.getFloorTsubo(1),
          f2Size: getters.getFloorArea(2),
          f2SizeTubo: getters.getFloorTsubo(2),
          f3Size: getters.getFloorArea(3),
          f3SizeTubo: getters.getFloorTsubo(3),
          gaihekiMenseki: getters.getGaihekiMenseki,
          naihekiMenseki: getters.getNaihekiMenseki,
          yaneSize: getters.allYaneSize,
          tanso: getters.tanso,
          spCustom: state.spec_formats.find(f => f.value == state.spec_format).label,
          sp1_1: state.options.pillar_material.find(o => o.value == state.pillar_material).label,
          sp1_2: state.options.roof_structure.find(o => o.value == state.roof_structure).label,
          sp1_3: state.options.insulation_material.find(o => o.value == state.insulation_material).label,
          sp2_1: state.options.exterior_wall_material.find(o => o.value == state.exterior_wall_material).label,
          sp2_2: state.options.exterior_roof_material.find(o => o.value == state.exterior_roof_material).label,
          sp3_1: state.options.interior_roof_finish.find(o => o.value == state.interior_roof_finish).label,
          sp3_2: state.options.interior_wall_finish.find(o => o.value == state.interior_wall_finish).label,
          sp3_3: state.options.interior_floor_finish.find(o => o.value == state.interior_floor_finish).label,
          sp4_1: state.options.anti_pollen_facility.find(o => o.value == state.anti_pollen_facility).label,
          sp4_2: state.options.natural_energy_facility.find(o => o.value == state.natural_energy_facility).label,
          sp4_3: state.options.floor_heating_facility.find(o => o.value == state.floor_heating_facility).label,
          sp4_4: state.options.hot_water_supply_facility.find(o => o.value == state.hot_water_supply_facility).label,
        }
      })
  },
}

const mutations = {
  gridSettled(state) {
    state.grid_settled = true
  },
  setSavedata(state, data) {
    Object.keys(data).forEach(prop => {
      state[prop] = data[prop]
    })
  },
  updateSaveDataId(state, value) {
    state.id = value
  },
  updateTitle(state, value) {
    state.title = value
  },
  updatePublic(state, value) {
    state.public = value
  },
  updateSpecSelected(state, value) {
    state.spec_selected = value
  },
  updateSpecFormat(state, value) {
    state.spec_selected = true
    state.spec_format = value
    var set = []
    switch (state.spec_format) {
      // 骨太安心国産材
      case 1: set = [1, 2, 1, 3, 1, 1, 1, 7, 4, 4, 4, 2]; break
      // 上質和風モダン
      case 2: set = [2, 1, 2, 3, 1, 2, 2, 7, 4, 4, 4, 2]; break
      // なんとなく洋風
      case 3: set = [4, 3, 2, 3, 2, 4, 6, 5, 4, 4, 4, 2]; break
      // 自然エネルギー充実
      case 4: set = [4, 4, 2, 4, 5, 3, 3, 5, 4, 2, 4, 2]; break
      // 抗花粉対策
      case 5: set = [4, 1, 1, 1, 2, 4, 5, 7, 3, 4, 3, 2]; break
      // とことん健康
      case 6: set = [4, 1, 1, 3, 5, 4, 5, 7, 4, 4, 3, 2]; break
      // こだわりカスタマイズ
      // case 7: set = [3, 1, 2, 4, 4, 2, 5, 2, 4, 4, 4, 2]; break
      // フォレスタイル標準仕様
      case 8: set = [3, 1, 2, 4, 4, 2, 5, 2, 4, 4, 4, 1]; break
    }
    if (set.length == 12) {
      state.pillar_material           = set[0]
      state.roof_structure            = set[1]
      state.insulation_material       = set[2]
      state.exterior_wall_material    = set[3]
      state.exterior_roof_material    = set[4]
      state.interior_roof_finish      = set[5]
      state.interior_wall_finish      = set[6]
      state.interior_floor_finish     = set[7]
      state.anti_pollen_facility      = set[8]
      state.natural_energy_facility   = set[9]
      state.floor_heating_facility    = set[10]
      state.hot_water_supply_facility = set[11]
    }
  },
  updatePillarMaterial(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.pillar_material = value
  },
  updateRoofStructure(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.roof_structure = value
  },
  updateInsulationMaterial(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.insulation_material = value
  },
  updateExteriorWallMaterial(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.exterior_wall_material = value
  },
  updateExteriorRoofMaterial(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.exterior_roof_material = value
  },
  updateInteriorRoofFinish(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.interior_roof_finish = value
  },
  updateInteriorWallFinish(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.interior_wall_finish = value
  },
  updateInteriorFloorFinish(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.interior_floor_finish = value
  },
  updateAntiPollenFacility(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.anti_pollen_facility = value
  },
  updateNaturalEnergyFacility(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.natural_energy_facility = value
  },
  updateFloorHeatingFacility(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.floor_heating_facility = value
  },
  updateHotWaterSupplyFacility(state, value) {
    state.spec_selected = true
    state.spec_format = 7
    state.hot_water_supply_facility = value
  },
  removeItem(state, data) {
    let floorIndex = data.floor - 1
    let items = state.items[floorIndex] || []
    let index = items.findIndex(item => item.id == data.id)
    if (index != -1) {
      items.splice(index, 1)
      Vue.set(state.items, floorIndex, items)
    }
  },
  updateItem(state, data) {
    let floorIndex = data.floor - 1
    let items = state.items[floorIndex] || []
    let index = items.findIndex(item => item.id == data.id)
    if (index != -1) {
      items[index] = data
    } else {
      items.push(data)
    }
    Vue.set(state.items, floorIndex, items)
  },
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/madori.js